import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MultiSelectComponent } from '../multi-select/multi-select.component';

@Component({
  selector: 'app-multi-select-trigger',
  templateUrl: './multi-select-trigger.component.html',
})
export class MultiSelectTriggerComponent extends MultiSelectComponent implements AfterViewInit {
  @Input() inputHeight;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    if(this.inputHeight){
      console.log(this.inputHeight);
    }
  }



}
